export default __webpack_public_path__ + "static/media/Montserrat-SemiBoldItalic.a8c82856.ttf";